import type { ComponentProps } from "react";
import { forwardRef, memo } from "react";

import styles from "./styles.module.scss";

export const PaginationContent = memo(
  forwardRef<HTMLUListElement, ComponentProps<"ul">>(({ ...props }, ref) => (
    <ul ref={ref} className={styles.paginationContent} {...props} />
  )),
);

PaginationContent.displayName = "PaginationContent";
